import React from 'react';


// Save new messages in a hash like this:
// {
//   conversationUniqueName1: lastMessage,
//   conversationUniqueName2: lastMessage,
//   ...
// }
export default function useNewLastMessages(client) {
  const [ lastMessages, setLastMessages ] = React.useState({});

  React.useEffect(function() {
    function onMessageAdded(message) {
      const { channel }    = message;
      const { uniqueName } = channel;
      setLastMessages(prevMessages => ({
        ...prevMessages,
        [uniqueName]: message
      }));
    }

    async function addListener() {
      client.on('messageAdded', onMessageAdded);
    }

    if (client)
      addListener();

    return async function() {
      if (client)
        client.removeListener('messageAdded', onMessageAdded);
    };
  }, [ client ]);

  return lastMessages;
}
